import Statistics from './StatisticsContainer';

export default Statistics;
